import React, { useEffect, useState } from 'react'
import millify from 'millify'
import { CommentList } from './comment.list.component'
import { createComment } from '../../services/ideas.service'
import { useSelector } from 'react-redux'
export const Comments = ({ data, commentsCount, setCommentCounts, ideaId, commentRef }) => {

    const user = useSelector(state => state.user)
    const [commentText, setCommentText] = useState('')
    const [commentsData, setCommentsData] = useState(data)

    const submitComment = async () => {
        if (commentText != "") {
            const comment = await createComment(ideaId, commentText, user.empId, user.empName)
            if (comment) {
                comment.data.comment.createdAt = new Date()
                setCommentText("")
                setCommentsData(oldData => [...oldData, comment.data.comment])
                setCommentCounts(commentsCount + 1)
            }
        }
    }

    return (
        <>
            <div className="col-12 comments" >
                <div className="card">
                    <div className="card-header py-1">
                        <small className="text-muted font-lato">{millify(commentsCount)} Comments</small>
                    </div>
                    {commentsData.length > 0 && (<div className="card-body">
                        <ul className="list-unstyled">
                            {commentsData.map(comment => {
                                return (
                                    <CommentList key={comment.COMMENTS_ID} data={comment} />
                                )
                            })

                            }
                        </ul>
                    </div>)}

                    <div className="card-footer bg-comments-card py-1">
                        <div className="d-flex justify-content-start align-items-center">
                            <div className="media">
                                <div className="starshot-ring mr-1">
                                    <div className="avatar">
                                        <div className="text-icon font-lato">{user.empName[0]}</div>
                                    </div>
                                </div>
                            </div>

                            <div className="input-group input-group-merge mr-1 form-send-message">
                                <input ref={commentRef}
                                    type="text"
                                    className="form-control"
                                    placeholder="Add a comment"
                                    onChange={(e) => setCommentText(e.target.value)}
                                    value={commentText}
                                    onKeyUp={e => {
                                        if (e.key == "Enter") {
                                            submitComment()
                                        }
                                    }}
                                />
                                <a className="input-group-append" onClick={submitComment}>
                                    <i className="fas fa-paper-plane text-p-green input-group-text" />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}